function toggleMenu(menu, shouldShowMenu) {
    if (shouldShowMenu) {
        menu.classList.add('oraStickyMenu--active');
    } else {
        menu.classList.remove('oraStickyMenu--active');
    }
}

function init() {
    const stickyMenu = document.querySelector('.js_oraStickyMenu'),
          heroImage = document.querySelector('.js_oraOfferImage');

    let observer;

    if (heroImage && stickyMenu) {
        observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                toggleMenu(stickyMenu, entry.intersectionRatio <= 0);
            });
        });

        observer.observe(heroImage);
    }
}

$(document).ready(init);
